import { render, staticRenderFns } from "./FS_scondHero.vue?vue&type=template&id=7fa08880&"
import script from "./FS_scondHero.vue?vue&type=script&lang=js&"
export * from "./FS_scondHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports